var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$StoreSendSchedule && _vm.$StoreSendSchedule[_vm.transferStore]
        ? [
            _vm.deliveryData
              ? _c(
                  "div",
                  { staticClass: "border pl-1" },
                  [
                    _vm.deliveryData?.sendDayOfWeek
                      ? [
                          _c("p", [
                            _vm._v("Прибытие препарата на склад "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.deliveryData.deliveryDate) +
                                  " (" +
                                  _vm._s(_vm.deliveryData.deliveryTime) +
                                  ") " +
                                  _vm._s(_vm.deliveryData.deliveryWeekDay)
                              ),
                            ]),
                          ]),
                        ]
                      : [_vm._v("\n        нет регулярной отправки\n      ")],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.runnerWorkSchedule
              ? _c(
                  "div",
                  [
                    _c("p", [_vm._v("Рабочие дни курьера")]),
                    _vm._v(" "),
                    _vm._l(_vm.runnerWorkSchedule, function (d) {
                      return _c("p", [
                        _vm._v(_vm._s(_vm.weekDays[d.day_num]) + " "),
                        _c("span", { staticClass: "badge badge-info" }, [
                          _vm._v(
                            _vm._s(
                              d.time === "00:00:00"
                                ? "Выходной"
                                : "До " + d.time
                            )
                          ),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }